import React, { useEffect } from 'react';
import { UnavailablePathReport } from '../types/api/PathReport';

type Props = {
  report: UnavailablePathReport;
  refetch: () => void;
};

export const PathReportBuildStatus: React.FC<Props> = ({ report, refetch }) => {
  useEffect(() => {
    if (report.report_status !== 'BUILDING') return;
    const timer = window.setInterval(refetch, 2000);
    return () => window.clearInterval(timer);
  }, [report.report_status, refetch]);

  return (
    <div
      className="d-flex justify-content-center align-items-center h-100 gap-2"
      role={report.report_status === 'FAILED' ? 'alert' : 'status'}
    >
      <span>{report.message}</span>
      {report.report_status === 'FAILED' && (
        <button className="btn btn-link" onClick={refetch}>
          Check again
        </button>
      )}
    </div>
  );
};
